import React from "react";
// import moment from 'moment'
import moment from 'moment-timezone'

import "./styles.css";
import PlaceHolderImage from "../../assets/candle-placeholder.png";

// Set default timezone
moment.tz.setDefault('America/New_York')

const UpdateOrderCard = ({ orderId, order, quantity, handleCancel, handleChangeView, setOrder, canCancel, canModify, status}) => {
  const image = order.image.replace(/.jpg(.*)/, '') + '_360x.jpg'

  console.log("image", image)
  return (
    <div className="ct-updatecard">
      <div className="ct-updatecard--image">
        <img src={image} alt="" />
      </div>
      <div className="ct-updatecard--content">
        <div className="ct-updatecard--heading--container">
          <span className="ct-updatecard--heading">
            {order.title}
          </span>
          <span className="ct-updatecard--price">
            ${Number(order.price * quantity).toFixed(2)}
          </span>
        </div>
        <span className="ct-updatecard--subheading">
          Quantity: {quantity}
        </span>
        <div className="ct-updatecard--preview">
          <p>{moment(order.date).format('MMMM D, YYYY')} between {moment(order.start_time).format('h:mm A')} - {moment(order.end_time).format('h:mm A')}</p>
        </div>
        { !order?.cancelled && !status && (
          <div className="ct-updatecard__actions">
            <button className="ct-modal__button" disabled={!canModify} onClick={() => handleChangeView('reschedule')}>Update Workshop</button>
            <button className="ct-modal__button" disabled={!canCancel} onClick={handleCancel}>
              Cancel Workshop
            </button>
          </div>
        )}
        {order?.cancelled && (
          <div className="ct-updatecard__actions">
            <h4 style={{margin: 0}}>Cancelled</h4>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateOrderCard;
